var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"width":"320px"}},[_c('LogTable',{attrs:{"entityId":'632',"entityType":6,"type":4}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }